import Store from '@/vuex/store';
import { PACKAGE_TYPE_PROVIDER } from '@alpitour/resources/package_types';
import { service_handler, is_service_present } from '@/services';
import { extract_and_normalize } from '@alpitour/utilities/keyd-map';
import { normalize_search_response } from '@alpitour/utilities/search-normalize';

const empty_promise = (reason) =>
  Promise.reject(new Error(reason || 'service not available'));

const response_normalization_layer = {
  keydsMap: (response) => ({
      ...response,
      data: { keydsMap: extract_and_normalize(response.data) },
    }),
  search: (response) => {
    const dates = {
      checkin: Store.state.liveat.checkin_date || '',
      checkout: Store.state.liveat.checkout_date || '',
    };
    return {
      ...response,
      data: normalize_search_response(response.data, dates),
    };
  },
};

const normalize_response = (service_key, response) => {
  const normalization = response_normalization_layer[service_key];
  if (normalization) {
    try {
      return normalization(response);
    } catch (e) {
      window.console.error(
        `[normalize_response] ${service_key} normalization failed`,
        e,
        response.data
      );
      return response;
    }
  }
  return response;
};

// Auto-inject package_type into the rybbit track context, mirroring the
// alpitour_rybbit_event contract. Explicit caller context wins on collision.
const with_package_type_track_context = (service_config, package_type) => {
  const { track } = service_config;
  if (!track) {
    return service_config;
  }

  let track_opts = track;
  if (typeof track === 'string') {
    track_opts = { name: track };
  }
  const { context = {} } = track_opts;

  return {
    ...service_config,
    track: { ...track_opts, context: { package_type, ...context } },
  };
};

export const alpitour_service_handler = (
  service_key,
  service_body = {},
  service_config = {}
) => {
  try {
    const { package_type } = Store.state.liveat;
    if (!package_type) {
      return empty_promise(`missing package_type`);
    }

    const prefix = PACKAGE_TYPE_PROVIDER[package_type];
    if (!prefix) {
      return empty_promise(`unknown package_type: ${package_type}`);
    }

    const prefixed_service = `${prefix}.${service_key}`;
    const service_name = is_service_present(prefixed_service)
      ? prefixed_service
      : service_key;

    return service_handler(
      service_name,
      service_body,
      with_package_type_track_context(service_config, package_type)
    ).then((response) => normalize_response(service_key, response));
  } catch (e) {
    return empty_promise(
      `alpitour_service_handler caught: ${e && e.message ? e.message : String(e)}`
    );
  }
};
